import type { EventPhoto, SearchFragment, SearchFragmentRest } from '../../types';
import type { ResponseWithType } from './types';

const searchFragment = ({ data }: ResponseWithType<SearchFragmentRest[]>): SearchFragment => {
  // for a fragment, we only every query for one tag, so we pluck the first item if it's available
  const { items, ...rest } = data[0] || {};
  const photos = items.map<EventPhoto>((photo) => {
    return { ...photo, __typename: 'EventPhoto' };
  });
  return { ...rest, photos, __typename: 'SearchFragment' };
};

export default searchFragment;
